import React, { useState, useRef, useEffect } from "react";
import '../../../scss/TypeTracNghiem.scss'
import he from 'he';
import { ThiTrucTuyenService } from 'services/ThiTrucTuyenService';
import { Checkbox } from "primereact/checkbox";
import { Toast } from 'primereact/toast';

const TypeTracNghiemMulti = (props) => {
    const { data, onChangeValue, isNhom, userId, time, overview, thitructuyen } = props;
    const isExample = data?.is_example == 1;
    const audioRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const toast = useRef(null);
    const IdDeThi = localStorage.getItem('IdDeThi');
    // Khởi tạo mảng đáp án đã chọn từ data.selected
    // Backend trả về: { id_cautraloi: [1, 2, 3] } hoặc { id_cautraloi: [] }
    const getInitialSelected = () => {
        if (!data?.selected) return [];

        // Nếu selected là object có id_cautraloi
        if (data.selected.id_cautraloi !== undefined) {
            const ids = data.selected.id_cautraloi;
            if (Array.isArray(ids)) {
                return ids.filter(id => id !== 0 && id !== null);
            } else if (ids !== 0 && ids !== null) {
                return [ids];
            }
        }

        return [];
    };

    const [dataSelected, setdataSelected] = useState(getInitialSelected());
    const debounceRef = useRef(null);
    const latestSelectedRef = useRef(dataSelected);
    const dataIdRef = useRef(data?.id);

    useEffect(() => {
        setdataSelected(getInitialSelected());
    }, [data?.id, data?.selected]);

    // Giữ ref luôn sync với state mới nhất (cho flush khi unmount)
    useEffect(() => {
        latestSelectedRef.current = dataSelected;
    }, [dataSelected]);

    useEffect(() => {
        dataIdRef.current = data?.id;
    }, [data?.id]);

    // Flush debounce khi component unmount (user bấm Next/Prev) để không mất đáp án
    useEffect(() => {
        return () => {
            if (debounceRef.current) {
                clearTimeout(debounceRef.current);
                debounceRef.current = null;
                // Gửi đáp án mới nhất trước khi unmount
                if (latestSelectedRef.current && latestSelectedRef.current.length > 0) {
                    onSubmitQuestion(dataIdRef.current, latestSelectedRef.current);
                }
            }
        };
    }, []);

    const getLetterLabel = (index) => {
        return String.fromCharCode(65 + index); // 65 là mã ASCII của 'A'
    };

    const onChange = (idAnswer, checked) => {
        let newSelected = [...dataSelected];

        if (checked) {
            // Thêm đáp án vào danh sách
            if (!newSelected.includes(idAnswer)) {
                newSelected.push(idAnswer);
            }
        } else {
            // Xóa đáp án khỏi danh sách
            newSelected = newSelected.filter(id => id !== idAnswer);
        }

        setdataSelected(newSelected);

        if (!isNhom) {
            // Gửi mảng đáp án đã chọn lên parent
            onChangeValue(newSelected);
        } else {
            // [Optimize] Debounce 500ms: gom nhiều tick checkbox nhanh thành 1 request
            clearTimeout(debounceRef.current);
            debounceRef.current = setTimeout(() => {
                debounceRef.current = null;
                onSubmitQuestion(data.id, newSelected);
            }, 500);
        }
    };

    const onSubmitQuestion = async (idquestion, selectedAnswers) => {
        const attemptCode = localStorage.getItem('exam_attempt_code');
        const typeExam = localStorage.getItem('typeExam');
        const IdDeThi = localStorage.getItem('IdDeThi');
        let body = {
            id_cauhoi: idquestion,
            id_cautraloi: selectedAnswers, // Mảng các id đáp án
            thoigianconlai: time,
            user_id: userId,
            loaibaithi: 1,
            attempt_code: attemptCode || null,
            dethitructuyen_id: IdDeThi,
            type_exam: typeExam
        };
        await ThiTrucTuyenService.submitquestionmulti(body);
    };

    const toggleAudio = async () => {
        try {
            const el = audioRef.current;
            if (!el) return;

            const playCountKey = `playCount_${userId}_${data.id}_${IdDeThi}`;
            const currentCount = parseInt(localStorage.getItem(playCountKey) || '0');

            if (isPlaying) {
                el.pause();
                setIsPlaying(false);
            } else {
                if (currentCount >= 2) {
                    toast.current.show({
                        severity: 'warn',
                        summary: 'Thông báo',
                        detail: 'Bạn đã hết lượt nghe cho câu hỏi này (tối đa 2 lần).',
                        life: 3000
                    });
                    return;
                }

                // Nếu bắt đầu nghe (lượt 1 hoặc 2), thì nghe lại từ đầu
                el.currentTime = 0;
                await el.play();
                setIsPlaying(true);

                const newCount = currentCount + 1;
                localStorage.setItem(playCountKey, newCount);
            }
        } catch (e) {
            // ignore play error
        }
    };

    return (
        <>
            <div className="conatiner-div1">
                <div>
                    <div>
                        <div style={{ width: '100%' }}
                            dangerouslySetInnerHTML={{
                                __html: he.decode(data.vanbancauhoi)
                            }}
                        />
                    </div>
                    <div>
                        {data.file && data.file.includes('.mp3') &&
                            <div style={{ marginTop: '20px', width: '100%' }}>
                                <audio
                                    controlsList="nodownload"
                                    key={data.id}
                                    ref={audioRef}
                                    style={{ display: 'none' }}
                                    onEnded={() => setIsPlaying(false)}
                                >
                                    <source src={data.file} type="audio/ogg" />
                                    <source src={data.file} type="audio/mpeg" />
                                </audio>
                                <button
                                    type="button"
                                    className="btn-audio-toggle"
                                    onClick={toggleAudio}
                                >
                                    <span className="icon">{isPlaying ? '⏸' : '⏵'}</span>
                                    <span className="text">
                                        <u>{isPlaying ? 'Stop' : 'Play'}</u>
                                    </span>
                                </button>
                            </div>
                        }
                    </div>

                    <div style={{ marginBottom: data.isnhom ? '100px' : '10px' }}>
                        {data && data.lstdapan.map((item, index) => {
                            const isChecked = dataSelected.includes(item.id);
                            const isCorrect = item.chinhxac == 1;
                            const showCorrectTick = overview && !isExample && isCorrect;
                            const showWrongTick = overview && !isExample && isChecked && !isCorrect;
                            return (
                                <div
                                    className="answer d-flex"
                                    key={index}
                                    style={overview ? {
                                        borderRadius: '8px',
                                        border: showWrongTick
                                            ? '1px solid #dc2626'
                                            : (showCorrectTick ? '1px solid #16a34a' : '1px solid transparent'),
                                        backgroundColor: showWrongTick
                                            ? '#fef2f2'
                                            : (showCorrectTick ? '#f0fdf4' : 'transparent'),
                                        padding: '8px 10px',
                                        marginBottom: '6px'
                                    } : undefined}
                                >
                                    <Checkbox
                                        inputId={`checkbox_${data.id}_${item.id}`}
                                        checked={isChecked}
                                        onChange={(e) => onChange(item.id, e.checked)}
                                        disabled={overview}
                                    />
                                    <label
                                        style={{ fontWeight: '400', marginLeft: '8px', cursor: overview ? 'default' : 'pointer' }}
                                        htmlFor={`checkbox_${data.id}_${item.id}`}
                                        onClick={() => !overview && onChange(item.id, !isChecked)}
                                    >
                                        <span style={{ marginLeft: 6 }}>{getLetterLabel(index)} .</span>
                                        <span style={{ marginLeft: 10 }}>{item.vanbanphanhoi}</span>
                                        {showCorrectTick && <span style={{ marginLeft: 10, color: '#16a34a', fontWeight: 700 }}>✓</span>}
                                        {showWrongTick && <span style={{ marginLeft: 10, color: '#dc2626', fontWeight: 700 }}>✗</span>}
                                    </label>
                                </div>
                            )
                        })}
                        {
                            data.vanbangiaithich && overview &&
                            <div style={{ color: 'red', marginLeft: 10, marginTop: '10px' }}>
                                <div style={{ fontWeight: '600' }}>Giải thích :</div>
                                <span style={{ color: 'black' }} dangerouslySetInnerHTML={{ __html: data.vanbangiaithich }}></span>
                            </div>
                        }

                    </div>
                </div>

            </div>
            <Toast ref={toast} />
        </>
    );
}

export default TypeTracNghiemMulti;

